import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';

import { CTA } from '../components/Layout/CTA';

import '../components/GlobalStyle.css';

import { FAQAccordion } from '../components/FAQComponents/FAQAccordions';
import { FadeLoad, FadeScroll } from '../components/styled/Motion.styled';



const FAQs = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Resources | FAQs</title>
                <link rel="canonical" href="https://bestpayment.solutions/faqs" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-50 bg-cream'>
                <Row className='pt-5 justify-content-evenly text-center'>
                    <Col>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Frequently Asked Questions</h2>
                            <h1 className='fs-48'>
                                Have questions about incentive programs?
                                <br />
                                We have answers.
                            </h1>
                        </FadeLoad>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5'>
                <Row className='pt-5 justify-content-center'>
                    <Col lg={8}>
                        <FAQAccordion />
                    </Col>
                </Row>
            </Container>
            <Container fluid className='bg-sky-tint-3 py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default FAQs;